import { Component, HostListener, OnInit } from '@angular/core';
import { Store } from '@ngxs/store';
import _ from 'lodash';
import { BaseDirectoryEditComponent } from '../base-directory-edit/base-directory-edit.component';

@Component({
   selector: 'samweb-string-column-edit',
   templateUrl: './string-column-edit.component.html',
   styleUrls: ['./string-column-edit.component.scss'],
})
export class StringColumnEditComponent extends BaseDirectoryEditComponent implements OnInit {
   public isValueSet = false;

   constructor(public store: Store) {
      super();
   }

   ngOnInit(): void {
      this.isValueSet = (this.value as string).length !== 0;
   }

   textChanged(value: string) {
      this.updateValue(value);
   }

   textChangedDebounced(value: string) {
      this.valueChanged.emit(this.value);
   }

   takeOtherClick() {
      this.takeOther.emit(this.valueUpdated);
   }

   updateValue(value: string) {
      this.value = value;
      this.isValueSet = this.value.length !== 0;
   }

   @HostListener('focusout', ['$event'])
   private onFocusOut(eventData: FocusEvent) {
      this.updateValue(_(this.value).trim());
      this.valueChanged.emit(this.value);
   }
}
